import { render, staticRenderFns } from "./ResponsiveRatingBars.vue?vue&type=template&id=ecd879bc&scoped=true"
import script from "./ResponsiveRatingBars.vue?vue&type=script&lang=js"
export * from "./ResponsiveRatingBars.vue?vue&type=script&lang=js"
import style0 from "./ResponsiveRatingBars.vue?vue&type=style&index=0&id=ecd879bc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ecd879bc",
  null
  
)

export default component.exports